export default function Footer() {
  return (
    <footer className="site_footer">
      <p>{`Copyright © ${new Date().getFullYear()} BYUN SEJUN. All Rights Reserved.`}</p>
    </footer>
  );
}
